import { gsap } from '../global/gsap';

const initAccordions = (accordions) => {

    accordions.forEach(acc => {
        const trigger = acc.querySelector('.js-trigger');
        const content = acc.querySelector('.js-content');

        if(content) {
            gsap.set(content, {
                height: 0,
                overflow: 'hidden'
            })
        }

        const handleAccordion = () => {
            let height;
            let active;

            if(acc.classList.contains('is-active')) {
                height = 0
            } else {
                height = 'auto'
            }

            acc.classList.toggle('is-active');

            gsap.to(content, {
                height,
            })
        }

        trigger.addEventListener('click', () => {
            handleAccordion()
        })
    })


}

export default initAccordions;